import { z } from "zod";

export const CampaignSchema = z.object({
  id: z.string().uuid(),
  parentId: z.string().uuid().optional().nullable(),
  isPublic: z.boolean().default(false),
  name: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  archivedAt: z.coerce.date().optional().nullable(),
  userId: z.string(),
  version: z.number().default(0),
  narrativeBridge: z.string().optional().nullable(),
  system_instructions: z.string().optional(),
  // Read-only, session-relative authority hint from
  // `verderem://campaigns/{id}`. Never persisted on Campaign rows.
  viewerIsGameMaster: z.boolean().optional(),
});

export type Campaign = z.infer<typeof CampaignSchema>;
